import { render, staticRenderFns } from "./RegularWithAssigneeTaskCell.vue?vue&type=template&id=35f1753d&scoped=true"
import script from "./RegularWithAssigneeTaskCell.vue?vue&type=script&lang=js"
export * from "./RegularWithAssigneeTaskCell.vue?vue&type=script&lang=js"
import style0 from "./RegularWithAssigneeTaskCell.vue?vue&type=style&index=0&id=35f1753d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1753d",
  null
  
)

export default component.exports